import { SitemapEventType } from "@ac-expo/api-types";
import { publicAxios } from "../axiosInstances";

export const getSitemapPages = async (): Promise<SitemapEventType[]> => {
  try {
    const { data } = await publicAxios.get<SitemapEventType[]>("/seo/sitemap");
    return data;
  } catch (error) {
    console.error("Error fetching sitemap pages:", error);
    return [];
  }
};
